/**
 * Admin Panel - Manage users and project permissions
 */
import React, { useState, useEffect } from 'react';
import { useAuthStore } from '../../stores/authStore';
import { UserManagement } from './UserManagement';
import { ProjectPermissions } from './ProjectPermissions';
import '../Dialogs/Dialog.css';
import './AdminPanel.css';

interface AdminPanelProps {
  isOpen: boolean;
  onClose: () => void;
}

type TabType = 'users' | 'permissions';

export const AdminPanel: React.FC<AdminPanelProps> = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState<TabType>('users');
  const { isAdmin } = useAuthStore();

  if (!isOpen) return null;

  // Only admins can access this panel
  if (!isAdmin()) {
    return (
      <div className="dialog-overlay" onClick={onClose}>
        <div className="dialog admin-panel" onClick={(e) => e.stopPropagation()}>
          <div className="dialog-header">
            <h2>⚠️ Prístup zamietnutý</h2>
            <button className="dialog-close" onClick={onClose}>✕</button>
          </div>
          <div className="dialog-content">
            <p>Nemáte oprávnenie na prístup k admin panelu.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog admin-panel" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h2>👤 Admin Panel</h2>
          <button className="dialog-close" onClick={onClose}>✕</button>
        </div>

        <div className="admin-tabs">
          <button
            className={`admin-tab ${activeTab === 'users' ? 'active' : ''}`}
            onClick={() => setActiveTab('users')}
          >
            👥 Používatelia
          </button>
          <button
            className={`admin-tab ${activeTab === 'permissions' ? 'active' : ''}`}
            onClick={() => setActiveTab('permissions')}
          >
            🔐 Oprávnenia projektov
          </button>
        </div>

        <div className="admin-content">
          {activeTab === 'users' && <UserManagement />}
          {activeTab === 'permissions' && <ProjectPermissions />}
        </div>
      </div>
    </div>
  );
};

